import { useEffect } from 'react';
import { useAuthContext } from '@shared/auth/AuthContext';
import { trackDemoStarted } from '@features/demo/analytics';
import Stack from '@mui/material/Stack';
import TopBar from '@shared/components/TopBar';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import SearchResults from '../../pages/search-result';
import SectionHeader from '@shared/components/SectionHeader';
import { useCurrentRoute } from '@shared//AppRoutes';
import { useAppSelector } from '@libs/redux/store';
import SideMenu from '@shared/components/SideMenu';
import { APP_LAYOUT_WIDTH } from '@shared//entity';
import { useUserDataQuery } from '../../shared/queries';
import { useAppNavigate } from '@shared//store';
import { LayoutBottomBar } from '@shared/layout/layout-bottom-bar/layout-bottom-bar';

const Layout = () => {
  const { isDemo, ready } = useAuthContext();
  const { data: userData } = useUserDataQuery();

  const isSearchActive = useAppSelector(state => state.appUi.isSearchActive);
  useEffect(() => {
    if (isDemo && ready) trackDemoStarted();
  }, [isDemo, ready]);

  const route = useCurrentRoute();
  const navigate = useAppNavigate();
  document.body.style.background = '#f6f6f6';

  return (
    <Stack
      spacing={isSearchActive ? 1 : 0}
      sx={{
        minWidth: { md: `${APP_LAYOUT_WIDTH}vw` },
        bgcolor: userData?.colorScheme ?? '#c81f5b',
      }}
      boxShadow="0px 0px 100px 0px rgba(0, 0, 0, 0.42)"
    >
      <Stack
        sx={{
          zIndex: '1',
          position: 'sticky',
          top: 0,
          width: { md: '100%' },
        }}
      >
        <TopBar />
        <SectionHeader onGoBack={() => navigate(-1)} route={route} />
      </Stack>
      <Box
        paddingX="10px"
        paddingY="12px"
        bgcolor="#f6f6f6"
        marginTop="-1px"
        borderRadius={isSearchActive ? '15px 15px 0 0' : 'none'}
        sx={{ bgcolor: '#f6f6f6', height: '100%', minHeight: '100vh' }}
      >
        <>
          {!isSearchActive && <Outlet />}
          <SearchResults />
        </>
      </Box>
      <LayoutBottomBar />
      <SideMenu />
    </Stack>
  );
};

export default Layout;
